import React from 'react';
import SectionHeader from '@components/common/SectionHeader';
import type { InvestmentIndicatorCardData } from '@app-types/investmentIndicators';
import InvestmentIndicatorCard from './InvestmentIndicatorCard';
import './InvestmentIndicatorCardsSection.less';

export interface InvestmentIndicatorCardsSectionProps {
  indicators: InvestmentIndicatorCardData[];
}

/**
 * Main indicators section: red-left SectionHeader (title 主要投資指標) + bordered
 * panel containing 4 cards (2×2 desktop, 1 column mobile).
 * Figma: web section 3164:13461, panel 3164:13463; mobile 3164:15718, 3490:22850.
 */
const InvestmentIndicatorCardsSection: React.FC<InvestmentIndicatorCardsSectionProps> = ({
  indicators,
}) => (
  <section className="investment-key-metrics" data-node-id="3164:13461">
    <SectionHeader
      title="主要投資指標"
      showHelp
      dataNodeId="3164:13462"
      as="h2"
    />
    <div className="investment-key-metrics__panel" data-node-id="3164:13463">
      {indicators.map((indicator) => (
        <InvestmentIndicatorCard key={indicator.key} data={indicator} />
      ))}
    </div>
  </section>
);

export default InvestmentIndicatorCardsSection;
